import React from 'react'

import { Helmet } from 'react-helmet'

import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Shocked's Website</title>
        <meta property="og:title" content="shocked's website" />
      </Helmet>
      <span>Text, HERE IS COOL!!</span>
    </div>
  )
}

export default Home
